import type { FormController } from '@adornis/forms/x-form-controller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import type { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AnmeldungPageRegistrationBase } from './anmeldung-component-formular-base.js';

/**
 * @customElement anmeldung-component-formular-attendance
 */
@customElement('anmeldung-component-formular-attendance')
export class AnmeldungPageRegistrationLangSelect extends AnmeldungPageRegistrationBase {
  @property({ attribute: false }) form!: FormController<Student>;
  @property({ attribute: false }) translation!: TranslationController<any>;
  @property({ attribute: false }) abwesenheitAgreed = false;

  override render() {
    return html`<cr-flex class="section-container" space="xl">
      <cr-flex class="sc-content">
        <cr-flex space="xl">
          <cr-h4 align="center">
            <b> Abmeldung bei Abwesenheit </b>
          </cr-h4>
          <cr-text>
            Solltest du zu einem Lernfördertermin nicht kommen können, entschuldige dich bitte vorher telefonisch bei
            deiner Ansprechperson von Chancenwerk e.V. Vielen Dank!
          </cr-text>
          <cr-text>Falls ich nicht zur Lernförderung kommen kann, melde ich mich vorher ab.</cr-text>
          <cr-flex space="sm" center horizontal crossaxis-center>
            <cr-toggle-button
              .value=${this.abwesenheitAgreed}
              label=""
              @value-picked=${e => {
                const event = new CustomEvent('value-picked', {
                  detail: {
                    value: e.detail.value,
                  },
                });
                this.dispatchEvent(event);
              }}
            ></cr-toggle-button>
            <cr-text>ja</cr-text>
          </cr-flex>

          <cr-button
            @click=${async () => {
              this.form.validate().catch(console.error);
            }}
          >
            ${this.translation.translate('next')}
          </cr-button>
        </cr-flex>
      </cr-flex>
    </cr-flex>`;
  }
}
